import { CalendarContextFactory } from './CalendarContextFactory';

export const calendarContextDependencies = {
  calendarInteractor: CalendarContextFactory.calendarInteractor(),
};
